import { render } from "./Ad.vue?vue&type=template&id=18cca1cc&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=18cca1cc&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cca1cc"]])

export default __exports__